import { useQuery } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../../../Context/AuthContext';

const useBusinessMerchant = (userId) => {
  const { user, token } = useContext(AuthContext);

  const fetchBusinessMerchant = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/users/merchants/${user?.userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { merchant: null, notSubmitted: true };
      }
      throw new Error('Error fetching merchant data. Please try again.');
    }
  };

  return useQuery(['businessMerchant', userId], fetchBusinessMerchant, {
    enabled: !!user?.userId && !!token,
    retry: false,
  });
};

export default useBusinessMerchant;
